<template>
  <button
    variant="facebook icon"
    class="sidebar-minimizer"
    type="button"
    @click="onClick()"
  ></button>
</template>
<script>
import { togglePs } from "@/mixins/togglePs";

export default {
  name: "sidebar-minimizer",
  mixins: [togglePs],
  mounted() {
    const isMinimized = document.body.classList.contains("sidebar-minimized");
    this.togglePs(!isMinimized);
  },
  methods: {
    onClick() {
      this.sidebarMinimize();
      this.brandMinimize();
    },
    sidebarMinimize() {
      const isMinimized = document.body.classList.toggle("sidebar-minimized");
      this.$emit("cui-sidebar-minimize", isMinimized);
      this.togglePs(!isMinimized);
    },
    brandMinimize() {
      document.body.classList.toggle("brand-minimized");
    },
  },
};
</script>
<style scoped>
.sidebar-minimizer {
  position: relative;
  z-index: 30;
  width: calc(100% - 12px);
  margin: 0 6px 8px;
  background: linear-gradient(180deg, #3156b6 0%, #27479a 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  box-shadow: 0 8px 18px -14px rgba(15, 23, 42, 0.55);
}

.fa-user {
  color: black !important;
}
</style>
<style>
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-minimizer {
    left: 6px;
    bottom: 8px;
    width: 38px !important;
    height: 50px !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
    border-radius: 12px !important;
    background: linear-gradient(180deg, #3156b6 0%, #27479a 100%) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 8px 18px -14px rgba(15, 23, 42, 0.55) !important;
  }

  .sidebar-minimized .sidebar .sidebar-minimizer::before {
    top: 0;
    right: 0;
    width: 38px !important;
    height: 50px !important;
    background-position: center;
    background-size: 10px !important;
  }
}

.sidebar .sidebar-minimizer::before {
  background-image: url("../../../public/img/png/sidebar-minimize.png");
  opacity: 0.95;
}

.sidebar .sidebar-minimizer:hover::before {
  background-image: url("../../../public/img/png/sidebar-minimize.png");
}
</style>
